'use client';
import { cn } from '@/lib/utils';

const TablistBtns = ({
  options = [],
  value = '',
  onChange,
  containerClass = '',
  labelSuffix = '',
}) => {
  return (
    <div className={cn('flex flex-wrap gap-1 sm:gap-2', containerClass)}>
      {options.map((option) => {
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            onClick={() => onChange?.(option.value)}
            className={cn(
              'px-4 py-2 text-sm font-medium rounded-xl transition-all duration-200 flex items-center gap-2',
              'hover:bg-brand-light/50 hover:text-brand-deep',
              value === option.value
                ? 'gradient-primary text-white shadow-brand hover:opacity-95'
                : 'bg-transparent text-muted-foreground'
            )}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {option.title}
            {labelSuffix && <span className="ml-1">{labelSuffix}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default TablistBtns;